function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_product_cat_life",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.625,0.870117 C14.7816,0.870117 12.9565,2.83943 12,4.61304 C11.0435,2.83938 9.21839,0.870117 6.375,0.870117 C2.76736,0.870117 0,3.79727 0,7.67956 C0,8.69252 0.202828,9.62773 0.576281,10.5264 L5.94037,10.5264 L7.15228,8.10251 C7.39125,7.62598 8.17125,7.62598 8.41022,8.10251 L10.5938,12.4696 L11.371,10.9151 L11.8398,9.97756 C12.0787,9.50103 12.8672,9.33106 13.0977,9.97756 L13.3594,10.5264 L23.4237,10.5264 C23.7972,9.62773 24,8.69252 24,7.67956 C24,3.79727 21.2326,0.870117 17.625,0.870117 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1487,11.9327 C12.8822,11.9327 12.7994,11.7823 12.6799,11.5441 L12.4221,10.927 L11.4846,12.802 L10.7073,14.3566 C10.4683,14.8331 10.2508,14.8331 10.0119,14.3566 L7.78147,9.9895 L7.00419,11.5441 C6.8847,11.7823 6.64166,11.9327 6.37522,11.9327 L1.31445,11.9327 C2.76163,14.2096 5.36792,16.3724 8.62808,19.1239 C9.54336,19.8964 10.517,20.7183 11.5394,21.6048 C11.672,21.7195 11.8361,21.7765 12.0002,21.7765 C12.1643,21.7765 12.3284,21.7195 12.4609,21.6048 C13.4833,20.7183 14.457,19.8964 15.3723,19.1239 C18.6325,16.3724 21.2387,14.2096 22.6859,11.9327 L13.1487,11.9327 Z",
  id: "Path"
})));

var SvgIcProductCatLife = function SvgIcProductCatLife(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcProductCatLife, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_product_cat_life.7305ff72.svg";
export { ForwardRef as ReactComponent };